import { render, staticRenderFns } from "./FaqThemes.vue?vue&type=template&id=f35fa790&scoped=true"
import script from "./FaqThemes.vue?vue&type=script&lang=js"
export * from "./FaqThemes.vue?vue&type=script&lang=js"
import style0 from "./FaqThemes.vue?vue&type=style&index=0&id=f35fa790&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35fa790",
  null
  
)

export default component.exports